import { Injectable } from '@angular/core';

import { ApModalComponentType } from 'webcommon/core-ui';
import { FindControlIdService } from 'webcommon/legacy-common';

import {
  FcFilterModalContext,
  ModalComponentTypeWithSize,
  ModalSizeEnum,
  ModalSizeType,
} from '../models/index';
import {
  FcAnsiListFilterModalComponent,
  FcGenericListFilterModalComponent,
} from './fc-filter-modals/index';
import { FcFilterModalBaseComponent } from './generic/index';

@Injectable({
  providedIn: 'root',
})
export class FcFilterConfig {
  private readonly fcFilterModalById = new Map<string, ModalComponentTypeWithSize<FcFilterModalBaseComponent>>();
  private readonly defaultFilterModal: ModalComponentTypeWithSize<FcFilterModalBaseComponent> = {
    component: FcGenericListFilterModalComponent,
    modalSize: ModalSizeEnum.small,
  };

  constructor() {
    this.registerFilterModal(FindControlIdService.ListEmploymentStatus, FcAnsiListFilterModalComponent);
    this.registerFilterModal(FindControlIdService.ListEthnicity, FcAnsiListFilterModalComponent);
    this.registerFilterModal(FindControlIdService.ListGender, FcAnsiListFilterModalComponent);
    this.registerFilterModal(FindControlIdService.ListGenderIdentity, FcAnsiListFilterModalComponent);
    this.registerFilterModal(FindControlIdService.ListMaritalStatus, FcAnsiListFilterModalComponent);
    this.registerFilterModal(FindControlIdService.ListPronoun, FcAnsiListFilterModalComponent);
    this.registerFilterModal(FindControlIdService.ListRace, FcAnsiListFilterModalComponent);
    this.registerFilterModal(FindControlIdService.ListRelationship, FcAnsiListFilterModalComponent);
    this.registerFilterModal(FindControlIdService.ListSexualOrientation, FcAnsiListFilterModalComponent);
  }

  getFilterModalTypeOrDefault(fcFilterModalContext: FcFilterModalContext) {
    const findControlModalType = this.fcFilterModalById.get(fcFilterModalContext.findControlConfig.FindControlBehavior.Id);
    return findControlModalType || this.defaultFilterModal;
  }

  registerFilterModal(
    findControlId: string,
    itemModalType: ApModalComponentType<FcFilterModalBaseComponent>,
    modalSize: ModalSizeType = ModalSizeEnum.small,
  ) {
    this.fcFilterModalById.set(findControlId, { component: itemModalType, modalSize });
  }
}
